// Teller Online Files
import { PublicHelpTag } from 'apps/public-portal/src/app/shared/help/help-tags';
import { helpTitle } from 'apps/public-portal/src/app/shared/help/help-titles';

// Teller Online Library Files
import { HelpArticle, HelpConditional } from 'teller-online-libraries/help';

export const SEARCH_HELP_ARTICLES: HelpArticle[] = [
    new HelpArticle({
        tag: PublicHelpTag.Search,
        order: 1,
        bookmark: 'where-do-i-start',
        title: helpTitle('where-do-i-start'),
        body: '<p>To get started, from the home page, select one of the large white blocks below '
            + 'the banner. This will take you to a search page. See <a '
            + "href='help#how-do-i-search'>How do I search?</a> for more details.</p>"
    }),
    new HelpArticle({
        tag: PublicHelpTag.Search,
        order: 2,
        bookmark: 'how-do-i-search',
        title: helpTitle('how-do-i-search'),
        body: '<p>Select one of the search options from the list. Then enter any required (*) '
            + 'information and click <b>Search</b>.</p>'
    }),
    new HelpArticle({
        tag: PublicHelpTag.Search,
        order: 3,
        bookmark: 'no-results-found',
        title: helpTitle('no-results-found'),
        body: '<p>First, confirm you are entering the correct information into the correct '
            + "fields. If you aren't sure where to find the information, please contact us.</p>"
            + '<p>If you are sure the information is correct, it is possible it may need to be '
            + 'paid for in person, please contact us.</p>'
    }),
    new HelpArticle({
        tag: PublicHelpTag.Search,
        order: 4,
        bookmark: 'how-do-i-know-correct-item',
        title: helpTitle('how-do-i-know-correct-item'),
        body: '<p>Clicking on the name of the item in your cart will take you to a details page '
            + 'where you can confirm the item is the one you intended to pay for.</p>'
    }),
    new HelpArticle({
        tag: PublicHelpTag.Search,
        order: 5,
        bookmark: 'what-is-item-details',
        title: helpTitle('what-is-item-details'),
        body: 'The item details page allows you to: <ul>'
            + '<li>Review the details of an item prior to payment.</li>'
            + '<li>Select a different payment option by clicking "Edit" next to the currently '
            + 'selected payment option.</li>'
            + '</ul>'
    }),
    new HelpArticle({
        tag: PublicHelpTag.Search,
        order: 6,
        bookmark: 'where-are-payment-options',
        title: helpTitle('where-are-payment-options'),
        body: '<p>Payment options are the different amounts that you can pay towards an '
            + 'account.</p>'
    }),
    new HelpArticle({
        tag: PublicHelpTag.Search,
        order: 19,
        conditions: [HelpConditional.Tenant],
        tenants: ['santaclara'],
        bookmark: 'how-to-pay-for-multiple-items',
        title: helpTitle('how-to-pay-for-multiple-items'),
        body: '<p>You can pay for multiple properties by first adding them to your cart '
            + ':shopping_cart:</p>'
            + '<ul>'
            + '<li>Go to Home :home:</li>'
            + '<li>Search for the first APN you want to pay</li>'
            + '<li>In the search results on the Item Details page, find the item to pay</li>'
            + '<li>Add it to the cart :add_shopping_cart:</li>'
            + '<li>Return to Home :home:</li>'
            + '<li>Repeat.</li>'
            + '</ul>'
            + '<p>Once desired properties are in the Cart, click Checkout and choose a Payment '
            + 'Method.  Up to 30 items can be paid in one transaction.</p>'
            + '<p>Note: All items in the Cart will be paid.  To exclude an APN or Assessment #, '
            + 'remove it from the Cart by clicking the :delete: icon.</p>'
    })
];
